type Props = {
  isSmall?: boolean;
  sizeStyle?: number;
  tailClassName?: string;
  arrowClassName?: string;
};

import styles from "./svg.module.scss";

const RightArrow = ({
  isSmall = true,
  sizeStyle = 1,
  tailClassName = "",
  arrowClassName = "",
}: Props) => {
  if (isSmall) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className={`${
          sizeStyle === 1 ? styles.arrowSize1 : styles.arrowSize2
        } ${arrowClassName}`}
        data-name="Layer 1"
        viewBox="0 0 38.38 15.32"
      >
        <defs />
        <path
          d="M.41 7.12a.41.41 0 0 0-.41.41v.34a.41.41 0 0 0 .41.42L37 8.27V7.1Z"
          className={`arrow-tail ${tailClassName}`}
        />
        <path
          d="M38.26 7.37 31 .12a.42.42 0 0 0-.59 0l-.24.24a.42.42 0 0 0 0 .59l6.11 6.1.61.61-.59.59-6.13 6.13a.41.41 0 0 0 0 .58l.24.24a.41.41 0 0 0 .58 0L38.26 8a.41.41 0 0 0 0-.63Z"
          className="arrow-head"
        />
      </svg>
    );
  }
  if (!isSmall) {
    return (
      <svg
        className={styles._big_right_arrow}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 183.762 43.271"
      >
        <path
          d="M161.223.833l-.67.67a1.137 1.137 0 000 1.608l16.913 16.913H1.637A1.137 1.137 0 00.5 21.161v.948a1.137 1.137 0 001.137 1.137h175.829l-16.913 16.913a1.137 1.137 0 000 1.608l.67.67a1.137 1.137 0 001.608 0l20-20a1.137 1.137 0 000-1.608l-20-20a1.137 1.137 0 00-1.608.004z"
          fill="#0f21d8"
          stroke="#707070"
          data-name="Group 533"
        />
      </svg>
    );
  }
};

export default RightArrow;
